<p>Your device is running iOS {{responsiveHelper.iOSversion}}.</p>
<p> For the best user experience, please upgrade your operating system to iOS {{responsiveHelper.iOSminVersion}} or above.</p>
<button
    pButton
    (click)="close()"
    >
    Continue anyway
</button>
